import React from 'react'
import { Bullet, Bullets, Info, Page, Screenshot, Section } from '../../../components/CommandControlComponents'

const LogsDecisions = () => (
  <Page
    title="Logs and Complex Decisions"
    intro="Control room logging records command activity, system changes, incident updates, and formal decision-making during the event."
  >
    <Section title="Control logs">
      <Bullets>
        <Bullet>Use New Log from the action bar to add command or general log entries — tick the &quot;Command&quot; option when the entry records a command instruction.</Bullet>
        <Bullet>Control Logs initially load 10 records and can load older entries on demand.</Bullet>
        <Bullet>Logs can be filtered by Incident, System, Command, Decision, and Log.</Bullet>
        <Bullet>The operator can adjust log text size from the Control Logs header.</Bullet>
        <Bullet>Non-system command-style logs can be added to the tactical command log.</Bullet>
      </Bullets>
      <Info>
        Who can do this? Writing a log requires Dispatcher or Call Taker
        access (or above). Viewers can read Control Logs but the composer is
        hidden.
      </Info>
      <Screenshot url="command-control/control-logs.png">
        Control Logs with type filters, text-size controls, and the Load older logs button.
      </Screenshot>
    </Section>

    <Section title="Incident log links">
      <Bullets>
        <Bullet>Incident log tags are clickable when they reference an incident.</Bullet>
        <Bullet>Clicking an incident tag opens that incident in the control room.</Bullet>
        <Bullet>Location changes, resource assignments, and incident updates are written into incident history where relevant.</Bullet>
      </Bullets>
    </Section>

    <Section title="System logs">
      <Bullets>
        <Bullet>System logs are created automatically for important operational changes.</Bullet>
        <Bullet>Examples include resource renames, status changes, event-map position updates, assignment changes, and event map updates.</Bullet>
        <Bullet>System logs help commanders audit what changed without relying only on free-text entries.</Bullet>
      </Bullets>
    </Section>

    <Section title="Complex decisions">
      <Bullets>
        <Bullet>Open Complex Decisions from the control-room action bar to see the decision register for the room.</Bullet>
        <Bullet>Create a new complex decision when a decision requires a structured rationale and action record.</Bullet>
        <Bullet>A complex decision records the problem, brief facts, the options considered (with rationale and the chosen option), the final decision, the decision rationale, and follow-up actions with a &quot;by when&quot; deadline.</Bullet>
        <Bullet>Decisions can be linked to a specific incident.</Bullet>
        <Bullet>Creating a complex decision writes a Decision entry into the command log.</Bullet>
      </Bullets>
      <Info>
        Who can do this? Any CAD role can read the decision register, but
        recording a complex decision and opening its linked action details are
        Commander-only.
      </Info>
    </Section>

    <Section title="Tactical Log">
      <Bullets>
        <Bullet>The Tactical Log is a standalone page outside the control room, available from the Command &amp; Control menu.</Bullet>
        <Bullet>It shows command logs for a chosen date range, with day-by-day navigation.</Bullet>
        <Bullet>Entries can be added directly to the tactical log and marked as flagged or pinned.</Bullet>
        <Bullet>Control-room command logs transferred to the tactical command log appear here alongside direct entries.</Bullet>
        <Bullet>The selected date range can be exported as a PDF, stamped with who printed it and when.</Bullet>
      </Bullets>
      <Info>
        Use complex decisions for decisions that may need later clinical,
        operational, or governance review, and the Tactical Log for the
        running command record across days.
      </Info>
    </Section>
  </Page>
)

export default LogsDecisions
